let React    = require('react');
let ReactDom = require('react-dom');
let Utils    = require('utils');

import ContentsModal from 'contents_modal';
// -------------------------------------------------------

class Link extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      emailModal    : false,
      passcodeModal : false,
      email         : '',
      password      : '',
      passcodeChars : ['', '', '', '', '', ''],
      loading       : false,
      error         : '',
    };
    this.otpRefs = Array.from({ length: 6 }, () => React.createRef());
  }

  // -------------------------------------------------------
  openModal(key) {
    this.setState({ [key]: true, error: '' });
  }

  closeModal(key) {
    this.setState({ [key]: false, error: '', email: '', password: '', passcodeChars: ['', '', '', '', '', ''] });
  }

  // -------------------------------------------------------
  async submitEmail(e) {
    e.preventDefault();
    const { email, password } = this.state;
    if (!email || !password) return;

    this.setState({ loading: true, error: '' });
    Utils.request('/api/login/link/email', { email, password },
      () => { Utils.redirect('/'); },
      (res) => { this.setState({ loading: false, error: res.body.message }); },
      true, false
    );
  }

  // -------------------------------------------------------
  async submitPasscode(e) {
    e.preventDefault();
    const passcode = this.state.passcodeChars.join('');
    if (passcode.length < 6) return;

    this.setState({ loading: true, error: '' });
    Utils.request('/api/login/link/passcode', { passcode },
      () => { Utils.redirect('/'); },
      (res) => { this.setState({ loading: false, error: res.body.message }); },
      true, false
    );
  }

  // -------------------------------------------------------
  handleOtpInput(index, e) {
    const val = e.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(-1);
    const chars = [...this.state.passcodeChars];
    chars[index] = val;
    this.setState({ passcodeChars: chars }, () => {
      if (val && index < 5) {
        this.otpRefs[index + 1].current.focus();
      }
    });
  }

  handleOtpKeyDown(index, e) {
    if (e.key === 'Backspace' && !this.state.passcodeChars[index] && index > 0) {
      this.otpRefs[index - 1].current.focus();
    }
  }

  handleOtpPaste(e) {
    e.preventDefault();
    const text = e.clipboardData.getData('text').replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 6);
    const chars = ['', '', '', '', '', ''];
    text.split('').forEach((c, i) => { chars[i] = c; });
    this.setState({ passcodeChars: chars }, () => {
      const focusIdx = Math.min(text.length, 5);
      this.otpRefs[focusIdx].current.focus();
    });
  }

  // -------------------------------------------------------
  render() {
    const { emailModal, passcodeModal, email, password, passcodeChars, loading, error } = this.state;
    const passcode = passcodeChars.join('');

    return (
      <div id="login">
        <div className="login-box">
          <div className="login-logo" />

          <div className="box link-box">
            <div className="auth0-notice">
              <span className="material-icons notice-icon">link</span>
              <p className="notice-title">アカウントの連携</p>
              <p className="notice-desc">
                ご利用のアカウントと連携してください。<br />
                一度連携すれば次回から自動でログインします。
              </p>
            </div>

            <button className="link-method-button" onClick={() => this.openModal('emailModal')}>
              <span className="material-icons">email</span>
              <span className="link-method-text">
                <strong>メールアドレス・パスワードで連携</strong>
                <small>登録済みのメールとパスワードを入力</small>
              </span>
              <span className="material-icons link-arrow">chevron_right</span>
            </button>

            <button className="link-method-button" onClick={() => this.openModal('passcodeModal')}>
              <span className="material-icons">pin</span>
              <span className="link-method-text">
                <strong>パスコードで連携</strong>
                <small>管理者から発行された6桁のコードを入力</small>
              </span>
              <span className="material-icons link-arrow">chevron_right</span>
            </button>
            
            <a className="auth0-login-button logout" href="/logout">
              <span className="material-icons">logout</span>
              ログアウト
            </a>
          </div>
        </div>

        {/* メール・パスワードモーダル */}
        <ContentsModal
          view     = {emailModal}
          width    = {380}
          height   = {320}
          close_ev = {() => this.closeModal('emailModal')}
          html     = {(
            <div className="link-modal-contents">
              <p className="link-modal-title">
                <span className="material-icons">email</span>
                メールアドレスで連携
              </p>
              <form className="link-modal-form" onSubmit={this.submitEmail.bind(this)}>
                <label className="link-modal-label">メールアドレス</label>
                <input className="link-modal-input" type="email" placeholder="example@email.com"
                  value={email}
                  onChange={e => this.setState({ email: e.target.value })} />

                <label className="link-modal-label">パスワード</label>
                <input className="link-modal-input" type="password" placeholder="パスワード"
                  value={password}
                  onChange={e => this.setState({ password: e.target.value })} />

                {error && <p className="link-error">{error}</p>}

                <a className={`button link-modal-button ${(!email || !password || loading) ? 'off' : ''}`}
                  onClick={(!email || !password || loading) ? undefined : this.submitEmail.bind(this)}>
                  {loading ? '確認中...' : '連携する'}
                </a>
                <button className="hide" type="submit" />
              </form>
            </div>
          )}
        />

        {/* パスコードモーダル */}
        <ContentsModal
          view     = {passcodeModal}
          width    = {380}
          height   = {280}
          close_ev = {() => this.closeModal('passcodeModal')}
          html     = {(
            <div className="link-modal-contents">
              <p className="link-modal-title">
                <span className="material-icons">pin</span>
                パスコードで連携
              </p>
              <form className="link-modal-form" onSubmit={this.submitPasscode.bind(this)}>
                <label className="link-modal-label">6桁のパスコード（英数字）</label>
                <div className="otp-group" onPaste={this.handleOtpPaste.bind(this)}>
                  {passcodeChars.map((ch, i) => (
                    <input
                      key={i}
                      ref={this.otpRefs[i]}
                      className={`otp-input ${ch ? 'filled' : ''}`}
                      type="text"
                      maxLength={1}
                      value={ch}
                      onChange={e => this.handleOtpInput(i, e)}
                      onKeyDown={e => this.handleOtpKeyDown(i, e)}
                      autoComplete="off"
                    />
                  ))}
                </div>

                {error && <p className="link-error">{error}</p>}

                <a className={`button link-modal-button ${(passcode.length < 6 || loading) ? 'off' : ''}`}
                  onClick={(passcode.length < 6 || loading) ? undefined : this.submitPasscode.bind(this)}>
                  {loading ? '確認中...' : '連携する'}
                </a>
                <button className="hide" type="submit" />
              </form>
            </div>
          )}
        />
      </div>
    );
  }
}
// -------------------------------------------------------

export default Link;
